/* TODO: t() */
export const FLUSH_VIEWSTATE_DELAY_MS = 1;
